<template>
	<div v-if="items.length > 0">
		<!-- <h1 class="page-title">Listado de productos</h1> -->

		<VueSlickCarousel
			:arrows="true"
			:dots="false"
			:slidesToScroll="1"
			:slidesToShow="3"
			:responsive="[
				{
					breakpoint: 1720,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 1400,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 2
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 1
					}
				}
			]"
			class="mt-3"
		>
			<template v-for="item in items">
				<div class="p-2" :key="item.id">
					<ProductItem :item="item" />
				</div>
			</template>
			<template #prevArrow>
				<div class="custom-arrow">
					<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chevron-left" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
   <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
   <polyline points="15 6 9 12 15 18"></polyline>
</svg>
				</div>
			</template>
			<template #nextArrow>
				<div class="custom-arrow">
					<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chevron-right" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
   <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
   <polyline points="9 6 15 12 9 18"></polyline>
</svg>
				</div>
			</template>
		</VueSlickCarousel>
	</div>
</template>

<script>
import gql from "graphql-tag"
import ProductItem from "@/components/ProductItem"

export default {
	components: {
		ProductItem
	},
	data() {
		return {
			items: []
		}
	},
	beforeMount() {
		this.load()
	},
	methods: {
		load() {
			return this.$apollo
				.query({
					query: gql`
						query($featured: Boolean, $status: String) {
							campers(featured: $featured, status: $status) {
								data {
									id
									name
									slug
									dimensions
									capacity
									waterTank
									image {
										id
										type
										filename
										url
										urlThumb
									}
									featured
									category{
										id slug
									}
								}
							}
						}
					`,
					variables: { featured: true, status: "ACTIVE" },
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.items = data.campers.data
				})
				.catch(() => {})
		}
	}
}
</script>


<style scoped lang="scss">
div ::v-deep .car-item {
	margin: 8px;
}

.custom-arrow{
	background: #ffffff;
	border: 2px solid #3a78c9;
	border-radius: 100px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 42px;
	height: 42px;
	cursor: pointer;
	transition: all 0.3s ease;


	&:hover{
		background: #3a78c930;

	}

	.icon{
		color: #3a78c9;
		width: 32px;
		height: 32px;
	}

	&:before{
		display: none;
	}
}
::v-deep .slick-list{
	overflow: hidden;
}

::v-deep .slick-arrow{
	z-index: 10;
	
	&.slick-prev{
			left: -10px;
			
		}
		&.slick-next{
			right: -10px;
		}

	
}

@media screen and (min-width: 481px) {
	::v-deep .slick-arrow{
		background: #ffffff00;
	&.slick-prev{
		left: -36px;
		
	}
	&.slick-next{
		right: -36px;
	}	
	}
}
</style>
